import { csvRows, unwrap } from './api.js';

// El resumen de pagos llega como JSON; el reporte de caja puede llegar como CSV.
export function cashRegisterRows(value) {
  const data = unwrap(value);
  if (data == null || data === '') return [];
  if (Array.isArray(data)) return data.map(row => row && typeof row === 'object' ? row : { Detalle: row });
  if (typeof data === 'object') {
    if ('resultado' in data) return cashRegisterRows(data.resultado);
    return Object.keys(data).length ? [data] : [];
  }
  const text = String(data).trim();
  if (!text) return [];
  return text.includes('¬') ? csvRows(text) : [{ Detalle: text }];
}
